import { API_URL } from "../../config/connect";

export async function postDecor(decorData) {
    const endpoint = `${API_URL}/api/v1/user/profile/company/decor`;

    try {
        const accessToken = localStorage.getItem("access_token");
        if (!accessToken) {
            throw new Error("Access token is missing");
        }

        const formData = new FormData();
        if (decorData.logo) {
            formData.append("logo", decorData.logo);
        }
        if (decorData.banner) {
            formData.append("banner", decorData.banner);
        }

        const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                // 'Content-Type' is NOT set manually for FormData
            },
            body: formData
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.statusText}`);
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Failed to post decor:', error);
        throw error;
    }
}